import { useCallback } from "react";
import { useGameStateContext } from "../GameStateProvider";

export const useModalActions = () => {
  const { dispatch } = useGameStateContext();

  const handleShowShop = useCallback(() => {
    dispatch({ type: "SHOW_MODAL", modal: "shop" });
  }, [dispatch]);

  const handleShowChallenges = useCallback(() => {
    dispatch({ type: "SHOW_MODAL", modal: "challenges" });
  }, [dispatch]);

  const handleShowRecipeBook = useCallback(() => {
    dispatch({ type: "SHOW_MODAL", modal: "recipeBook" });
  }, [dispatch]);

  const handleShowSettings = useCallback(() => {
    dispatch({ type: "SHOW_MODAL", modal: "settings" });
  }, [dispatch]);

  const handleHideModal = useCallback(() => {
    dispatch({ type: "HIDE_MODAL" });
  }, [dispatch]);

  return {
    handleShowShop,
    handleShowChallenges,
    handleShowRecipeBook,
    handleShowSettings,
    handleHideModal,
  };
};
